require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconArrowRight.tsx
var IconArrowRight_exports = {};
__export(IconArrowRight_exports, {
  default: () => IconArrowRight_default
});
module.exports = __toCommonJS(IconArrowRight_exports);

// src/assets/monochrome/arrowRight.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgArrowRight = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6313 13.7563C12.2896 14.098 12.2896 14.652 12.6313 14.9937C12.973 15.3354 13.527 15.3354 13.8687 14.9937L18.2437 10.6187C18.5854 10.277 18.5854 9.72299 18.2437 9.38128L13.8687 5.00628C13.527 4.66457 12.973 4.66457 12.6313 5.00628C12.2896 5.34799 12.2896 5.90201 12.6313 6.24372L15.4876 9.1L2.5 9.1C2.01675 9.1 1.625 9.50294 1.625 10C1.625 10.4971 2.01675 10.9 2.5 10.9L15.4876 10.9L12.6313 13.7563Z", fill: "#818898" }) });
var arrowRight_default = SvgArrowRight;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconArrowRight.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconArrowRight = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(arrowRight_default, {}) });
};
IconArrowRight.displayName = "IconArrowRight";
var IconArrowRight_default = IconArrowRight;
